// "Powered by <sponsor>" line for the agenda overview/calendar cards.
// Returns '' when the session has no named sponsors. Plain function (no Vue
// APIs) so it's safe to import anywhere, including SSR/Workers.
export function sponsorPoweredByLine(session) {
    const sponsors = session?.sponsors;
    if (!Array.isArray(sponsors) || !sponsors.length) return '';
    const names = sponsors.map(s => s?.name).filter(Boolean).join(', ');
    return names ? `Powered by ${names}` : '';
}
